import createIcon from "../createIcon";
import React from "react";

export const SearchIcon = createIcon({
  path: (
    <path
      d="M30.9993 27.9993H29.4193L28.8593 27.4593C31.2593 24.6593 32.4993 20.8393 31.8193 16.7793C30.8793 11.2193 26.2393 6.7793 20.6393 6.0993C12.1793 5.0593 5.0593 12.1793 6.0993 20.6393C6.7793 26.2393 11.2193 30.8793 16.7793 31.8193C20.8393 32.4993 24.6593 31.2593 27.4593 28.8593L27.9993 29.4193V30.9993L36.4993 39.4993C37.3193 40.3193 38.6593 40.3193 39.4793 39.4993C40.2993 38.6793 40.2993 37.3393 39.4793 36.5193L30.9993 27.9993ZM18.9993 27.9993C14.0193 27.9993 9.9993 23.9793 9.9993 18.9993C9.9993 14.0193 14.0193 9.9993 18.9993 9.9993C23.9793 9.9993 27.9993 14.0193 27.9993 18.9993C27.9993 23.9793 23.9793 27.9993 18.9993 27.9993Z"
      fill="currentColor"
    />
  )
});
